<template>
  <div class="form-item">
    <div class="item-identifier">
      <p class="item-title">{{ item.name }}</p>
      <div class="identifier-icons">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="item.duplicable"
          @click="duplicateField"
        >
          <path
            d="M15.6783 13.0596V1.27393H3.89258"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.0592 3.89307H1.27344V15.6788H13.0592V3.89307Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- todo : improve and reintroduce library -->
        <!-- <svg
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="item.libraryEnabled"
          @click="activateLibrary"
        >
          <path
            d="M13.7799 14.369C15.0456 14.369 16.0716 13.343 16.0716 12.0773C16.0716 10.8117 15.0456 9.78564 13.7799 9.78564C12.5143 9.78564 11.4883 10.8117 11.4883 12.0773C11.4883 13.343 12.5143 14.369 13.7799 14.369Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.30339 16.9881C4.56904 16.9881 5.59505 15.9621 5.59505 14.6965C5.59505 13.4308 4.56904 12.4048 3.30339 12.4048C2.03773 12.4048 1.01172 13.4308 1.01172 14.6965C1.01172 15.9621 2.03773 16.9881 3.30339 16.9881Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.0719 4.54785L5.5957 7.1669"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.5957 14.6965V3.23819L16.0719 0.619141V12.0775"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg> -->
      </div>
    </div>
    <div class="input-grouping">
      <div
        class="scs-input-wrapper"
        v-for="(input, index) in item.fields"
        :key="index"
      >
        <Input
          class="scs-input"
          :placeholder="input.inputTitle"
          :heading="input.inputTitle"
          :initialValue="input.value"
          v-if="input.inputType !== 'textarea' && input.inputType !== 'select'"
          @scs-input="fieldInput($event, index, input)"
        />
        <Select
          class="scs-input"
          :heading="input.inputTitle"
          :initial="input.value"
          :formatter="selectFormatter"
          @input="fieldInput($event, index, input)"
          v-if="input.inputType === 'select'"
          :options="input.options"
        />
        <TextArea
          class="scs-input"
          :placeholder="input.inputTitle"
          :heading="input.inputTitle"
          :initialValue="input.value"
          @scs-input="fieldInput($event, index, input)"
          v-if="input.inputType === 'textarea'"
        />
        <p class="print">{{ input.value }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import Input from "@/Components/Elements/Input.vue";
import Select from "@/Components/Elements/Select.vue";
import TextArea from "@/Components/Elements/TextArea.vue";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    selectFormatter(value) {
      if (value.optionValue) {
        return value.optionValue;
      } else if (value.value) {
        return value.value;
      } else {
        return value;
      }
    },
    fieldInput($event, index, input) {
      console.log($event, input);
      if (this.item.libraryEnabled) {
        this.autocomplete = true;
      }
      input.value = $event;
    },
    duplicateField() {
      this.$emit("duplicate-field");
    },
    activateLibrary() {
      this.$emit("activate-library");
    },
  },
  created() {},
  components: {
    Input,
    Select,
    TextArea,
  },
  props: ["item"],
  emits: ["duplicate-field", "activate-library"],
};
</script>
<style scoped>
.form-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: left;
  width: calc(100% - 20px);
  margin: 10px;
  box-sizing: border-box;
  text-align: left;
}

.item-identifier {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 40px 0 0;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
}

.item-title {
  width: 100%;
  display: -webkit-box;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.identifier-icons {
  display: flex;
}

svg {
  margin: 0 5px;
  cursor: pointer;
}

.input-grouping {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  position: relative;
  width: 100%;
}
.scs-library-autocomplete {
  border: 1px solid var(--secondaryColor);
  position: absolute;
  z-index: 3;
}
.scs-input-wrapper {
  width: 100%;
  margin: 3px;
  box-sizing: border-box;
}

.scs-input {
  width: 100%;
  font-size: 0.75rem;
}

.print {
  display: none;
}

@media print {
  .scs-input,
  .identifier-icons {
    display: none;
  }
  .print {
    display: unset;
  }
}
</style>
